import React from 'react';
import PageRoot from '../PageRoot';

export default function MinimalPageLayout({ className = '', children }) {
    return (
        <PageRoot variant="minimal" className={className}>
            {children}
        </PageRoot>
    );
}
